var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175536_21002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73046 0.0585403C6.92577 0.292915 5.27342 0.984322 3.82811 2.10151C3.37108 2.45698 2.59374 3.2226 2.21483 3.69135C1.13671 5.02729 0.421861 6.60542 0.117174 8.32417C0.00779894 8.93354 -0.0351698 10.3984 0.0351427 11.0664C0.203111 12.6249 0.74608 14.1523 1.58983 15.4492C1.97264 16.0351 2.30858 16.4531 2.83202 16.9882C4.46874 18.6679 6.53514 19.6835 8.88671 19.957C9.41014 20.0195 10.6836 20.0078 11.25 19.9414C14.1719 19.5781 16.7812 17.9414 18.4101 15.4492C19.2305 14.1953 19.7539 12.7539 19.9414 11.2499C20.0195 10.6171 20.0195 9.38667 19.9414 8.74995C19.582 5.85151 17.9492 3.23432 15.4883 1.61713C14.2031 0.773384 12.7734 0.249947 11.25 0.0585403C10.6562 -0.0117722 9.29296 -0.0117722 8.73046 0.0585403ZM15.1523 8.78901C15.582 8.85932 15.8789 9.06245 16.0781 9.42182C16.1797 9.60932 16.1914 9.66401 16.1914 9.99995C16.1914 10.4257 16.125 10.5937 15.8594 10.8593C15.6601 11.0585 15.457 11.1601 15.1523 11.2109C14.8086 11.2656 5.19139 11.2656 4.84764 11.2109C4.41796 11.1406 4.12108 10.9374 3.92186 10.5781C3.8203 10.3906 3.80858 10.3359 3.80858 9.99995C3.80858 9.69135 3.82421 9.60151 3.89842 9.46479C4.09374 9.0937 4.41405 8.85932 4.80858 8.79292C5.11327 8.74214 14.8398 8.74214 15.1523 8.78901Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175536_21002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDndIcon);
export default __webpack_public_path__ + "static/media/dnd-icon.1b1ceb80f800c86a7ac58222660443b9.svg";
export { ForwardRef as ReactComponent };